module.exports = __webpack_public_path__ + "img/banner-ctv-1.eec5ecd9.png";